// import { AlertCircle, ArrowRight, ChevronDown } from 'lucide-react';
// import { Button } from '@/components/ui/button';
// import { mapErrorToUserMessage } from '@/lib/error-messages';

// interface AdFailedBannerProps {
//   errorMessage?: string | null;
//   onRestart: () => void;
//   isRestarting: boolean;
//   isExpanded?: boolean;
//   onToggleExpanded?: () => void;
// }

// #4601 — Ad Incomplete / REBUILD AD flow deprecated
// export function AdFailedBanner({
//   errorMessage,
//   onRestart,
//   isRestarting,
//   isExpanded = false,
//   onToggleExpanded,
// }: AdFailedBannerProps) {
//   const userFriendlyError = mapErrorToUserMessage(errorMessage);
//
//   return (
//     <div className={`bg-[#FEE2E2] border-l-4 border-l-[#FCA5A5] rounded-lg p-4 mb-4 transition-colors${onToggleExpanded ? ' cursor-pointer hover:bg-[#FDD6D6]' : ''}`} onClick={onToggleExpanded}>
//       <div className="flex items-center gap-4">
//         <div className="bg-white rounded-lg shadow p-2 self-start mt-0.5">
//           <AlertCircle className="h-5 w-5 text-[#B91C1C]" />
//         </div>
//         <div className="flex flex-1 items-center justify-between gap-6">
//           <div>
//             <h3 className="text-base font-semibold text-gray-900 mb-1">Ad Incomplete</h3>
//             <p className="text-gray-900 text-sm">{userFriendlyError}</p>
//           </div>
//           <div className="flex items-center gap-2 shrink-0">
//             <Button
//               size="sm"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 onRestart();
//               }}
//               disabled={isRestarting}
//               className="w-[180px] h-9 bg-[#290BD9] hover:bg-[#2309C5] text-white shadow-lg flex items-center justify-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
//             >
//               <span>{isRestarting ? 'REBUILDING AD...' : 'REBUILD AD'}</span>
//               <ArrowRight className="h-4 w-4" />
//             </Button>
//             {onToggleExpanded && (
//               <Button
//                 variant="ghost"
//                 size="sm"
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   onToggleExpanded();
//                 }}
//                 className="h-8 w-8 p-0 text-gray-400 hover:text-gray-700"
//               >
//                 <ChevronDown
//                   className={`h-4 w-4 transition-transform duration-200 ${
//                     isExpanded ? 'rotate-180' : ''
//                   }`}
//                 />
//               </Button>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

export function AdFailedBanner(_props: {
  errorMessage?: string | null;
  onRestart: () => void;
  isRestarting: boolean;
  isExpanded?: boolean;
  onToggleExpanded?: () => void;
}) {
  return null;
}

